export default __webpack_public_path__ + "static/media/2.91dd57a7.png";